/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const powerElectricalSystemsEnumsCurrentStatusOptionEnum = {
    Online: 'Online',
    Offline: 'Offline',
    Busy: 'Busy',
    Overwhelmed: 'Overwhelmed',
    Saturated: 'Saturated',
    Other: 'Other',
} as const;

export type PowerElectricalSystemsEnumsCurrentStatusOptionEnumKey =
    (typeof powerElectricalSystemsEnumsCurrentStatusOptionEnum)[keyof typeof powerElectricalSystemsEnumsCurrentStatusOptionEnum];

export type PowerElectricalSystemsEnumsCurrentStatusOption = PowerElectricalSystemsEnumsCurrentStatusOptionEnumKey;
